import { http } from '@/lib/axios';
import { unwrap, toApiError } from '@/lib/unwrap';
import type { ApiEnvelope } from '@/types/api';
import type { GroupBookingType } from '@/types/sale';

/**
 * GET /group-booking-types — every group type (built-in and admin-added,
 * #1726), in display order. Read-only; any signed-in cashier may call it.
 */
export async function getGroupBookingTypes(): Promise<GroupBookingType[]> {
  try {
    const res = await http.get<ApiEnvelope<GroupBookingType[]>>('/group-booking-types');
    const data = unwrap(res.data);
    return Array.isArray(data) ? data : [];
  } catch (error) {
    throw toApiError(error);
  }
}
